import NP from 'number-precision'

export const ALL_EXPENSE_YEARS = 'All Years'

const GROUP_YEARLY = 0
const GROUP_QUARTERLY = 1
const GROUP_MONTHLY = 2
const GROUP_CATEGORY = 4

export function validateExpensePreferences(setting) {
    const preferences = setting || {}
    const groupBy = Number(preferences.expenseGroupBy)
    const sortType = Number(preferences.expenseSortType)
    const sortAscending = Number(preferences.expenseSortAscending)
    const year = Number(preferences.expenseFilterYear)
    preferences.expenseFilterYear = preferences.expenseFilterYear === ALL_EXPENSE_YEARS
        || (Number.isInteger(year) && year >= 1970 && year <= 3000)
        ? (preferences.expenseFilterYear === ALL_EXPENSE_YEARS ? ALL_EXPENSE_YEARS : String(year))
        : ALL_EXPENSE_YEARS
    preferences.expenseGroupBy = [GROUP_YEARLY, GROUP_QUARTERLY, GROUP_MONTHLY, GROUP_CATEGORY].includes(groupBy)
        ? groupBy : GROUP_MONTHLY
    preferences.expenseSortType = [0, 1].includes(sortType) ? sortType : 1
    preferences.expenseSortAscending = [0, 1].includes(sortAscending) ? sortAscending : 0
    return preferences
}

export function buildExpenseSections(expenses, groupBy, orderName, ascending, locale, noCategory) {
    const groups = new Map()
    expenses.forEach(expense => {
        const group = expenseGroup(expense, groupBy, locale, noCategory)
        if (!groups.has(group.key)) {
            groups.set(group.key, {title: group.title, sortValue: group.sortValue, expenses: []})
        }
        groups.get(group.key).expenses.push(expense)
    })

    const sections = Array.from(groups.values())
    sections.sort((left, right) => compareValue(left.sortValue, right.sortValue, ascending, locale))
    sections.forEach(section => {
        section.expenses.sort((left, right) => compareExpense(left, right, orderName, ascending, locale))
        section.total = section.expenses.reduce((sum, expense) => NP.plus(sum, Number(expense.total)), 0)
    })
    return sections
}

function expenseDateEpoch(expense) {
    return Number(expense.expenseDate == null ? 0 : expense.expenseDate)
}

function expenseGroup(expense, groupBy, locale, noCategory) {
    if (groupBy === GROUP_CATEGORY) {
        const category = String(expense.categoryName == null ? '' : expense.categoryName).trim()
        const title = category === '' ? noCategory : category
        return {key: `category:${title}`, title, sortValue: title}
    }

    const date = new Date(expenseDateEpoch(expense) * 1000)
    const year = date.getFullYear()
    if (groupBy === GROUP_YEARLY) {
        return {key: `year:${year}`, title: String(year), sortValue: year}
    }
    if (groupBy === GROUP_QUARTERLY) {
        const quarter = Math.floor(date.getMonth() / 3) + 1
        return {key: `quarter:${year}:${quarter}`, title: `Q${quarter} ${year}`, sortValue: year * 10 + quarter}
    }
    if (groupBy === GROUP_MONTHLY) {
        const month = date.getMonth()
        const title = new Intl.DateTimeFormat(locale, {year: 'numeric', month: 'long'}).format(date)
        return {key: `month:${year}:${month}`, title, sortValue: year * 100 + month}
    }
    const month = date.getMonth()
    return {
        key: `month:${year}:${month}`,
        title: new Intl.DateTimeFormat(locale, {year: 'numeric', month: 'long'}).format(date),
        sortValue: year * 100 + month
    }
}

function compareExpense(left, right, orderName, ascending, locale) {
    let comparison
    if (orderName === 'categoryName') {
        comparison = String(left.categoryName || '').localeCompare(String(right.categoryName || ''), locale, {sensitivity: 'base'})
    } else if (orderName === 'expenseDate') {
        comparison = expenseDateEpoch(left) - expenseDateEpoch(right)
    } else if (orderName === 'total') {
        comparison = Number(left.total) - Number(right.total)
    } else {
        comparison = expenseDateEpoch(left) - expenseDateEpoch(right)
    }
    if (comparison === 0) {
        comparison = String(left.innerUUID).localeCompare(String(right.innerUUID))
    }
    return ascending ? comparison : -comparison
}

function compareValue(left, right, ascending, locale) {
    const comparison = typeof left === 'string'
        ? left.localeCompare(right, locale, {sensitivity: 'base'})
        : left - right
    return ascending ? comparison : -comparison
}
